export default __webpack_public_path__ + "static/media/me.c4269a9c.jpg";